import React from 'react';

const IconBonus = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.01391 3.21128C4.36188 3.9185 4.01211 4.86809 4.00075 5.99992H3C2.44772 5.99992 2 6.44763 2 6.99992V10.9999C2 11.5522 2.44772 11.9999 3 11.9999H4V20.9999C4 21.5522 4.44772 21.9999 5 21.9999H19C19.5523 21.9999 20 21.5522 20 20.9999V11.9999H21C21.5523 11.9999 22 11.5522 22 10.9999V6.99992C22 6.44763 21.5523 5.99992 21 5.99992H19.9992C19.9879 4.86809 19.6381 3.9185 18.9861 3.21128C18.1365 2.28976 16.9229 1.94372 15.7725 2.00733C14.3993 2.08326 12.9384 2.76283 12 3.97536C11.0616 2.76283 9.60071 2.08326 8.22751 2.00733C7.07714 1.94372 5.86352 2.28976 5.01391 3.21128ZM10.839 5.99992L5.99993 5.99992C6.01061 5.2877 6.23262 4.83998 6.48433 4.56696C6.8386 4.18271 7.41535 3.96548 8.11709 4.00428C9.26781 4.06791 10.4236 4.78384 10.839 5.99992ZM13 19.9999H18V11.9999H13V19.9999ZM11 11.9999V19.9999H6V11.9999H11ZM13 9.99992H20V7.99992L13 7.99992V9.99992ZM11 7.99992V9.99992H4V7.99992L11 7.99992ZM18.0001 5.99991L13.161 5.99992C13.5764 4.78384 14.7322 4.06791 15.8829 4.00428C16.5846 3.96548 17.1614 4.18271 17.5157 4.56696C17.7674 4.83998 17.9894 5.2877 18.0001 5.99991Z"
        fill="#06090D"
      />
    </svg>
  );
};

export default IconBonus;
